module.exports = __webpack_public_path__ + "static/media/18ECA45.19243f92.jpg";